import { isNud } from '@/shared/utilities/typing'

/**
 * 販売店 エンティティ
 */
class Distributor {
    distributor_id;
    distributor_code;
    distributor_name;
    distributor_name_kana;
    zip_code;
    address_1;
    address_2;
    address_3;
    phone;
    fax;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.distributor_id = properties.distributor_id;
        this.distributor_code = properties.distributor_code;
        this.distributor_name = properties.distributor_name;
        this.distributor_name_kana = properties.distributor_name_kana;
        this.zip_code = properties.zip_code;
        this.address_1 = properties.address_1;
        this.address_2 = properties.address_2;
        this.address_3 = properties.address_3;
        this.phone = properties.phone;
        this.fax = properties.fax;

    }

    get full_address() {
        return (this.address_1 ?? '') + (this.address_2 ?? '') + (this.address_3 ?? '');
    }
}

export default Distributor;
